import React from 'react';
import { Column } from 'react-table';
import { FormattedMessage } from 'react-intl';
import { any } from 'ramda';
import { ISurvey } from '../../../../common/models/survey/ISurvey';
import { SortType } from '../../../../common/enums/SortType';
import { formatDate } from '../../../../common/helpers/dateHelper';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { ReactComponent as PreviewIcon } from '../../../../assets/icons/preview.svg';
import { ISelectedSurvey } from '../../../../common/models/survey/ISelectedSurvey';
import styles from './styles.module.scss';
import Icon from '../../../../components/Icon';
import Tooltip from '../../../../components/Tooltip';
import TextOverflowTooltip from '../../../../components/TextOverflowTooltip';
import EmptyFieldPlaceholder from '../../../../components/EmptyFieldPlaceholder';

export const getColumns = (onPreview: IBindingCallback1<string>, lastUsed: ISelectedSurvey[]): Column[] => [
  {
    Header: () => <FormattedMessage id="step4.lastUsedDate" defaultMessage="Last used date" />,
    accessor: 'lastSendDate',
    Cell: ({ cell: { value } }) => (value ? formatDate(value) : <EmptyFieldPlaceholder />),
    width: 85,
    sortType: SortType.Date
  },
  {
    Header: () => <FormattedMessage id="surveyTable.favorite" defaultMessage="Favorite" />,
    accessor: 'isFavorite',
    Cell: ({ cell: { value } }) => (
      <div style={{ maxWidth: 55 }} className="table-center">
        <Tooltip content={<FormattedMessage id="iconButtonLable.favorite" defaultMessage="Favorite" />}>
          {value
            ? <Icon icon="activeStar" className="table-icon cursor-pointer" />
            : <Icon icon="inactiveStar" className="table-icon hover-icon-stroke cursor-pointer" />}
        </Tooltip>
      </div>
    ),
    width: 90,
    sortType: SortType.Favorites
  },
  {
    Header: () => <FormattedMessage id="surveyTable.surveyTitle" defaultMessage="Survey title" />,
    accessor: 'name',
    Cell: ({ row: { original } }) => {
      const { name, description, id } = original as ISurvey;
      return (
        <div className="d-flex flex-column">
          <div className={styles.titleCell}>
            {any(lastUsedSurvey => id === lastUsedSurvey.id, lastUsed)
              ? (
                <>
                  <TextOverflowTooltip content={name} width={113}>
                    <span className={styles.surveyTitleText}>{name}</span>
                  </TextOverflowTooltip>
                  <span className={styles.recommended}>
                    <FormattedMessage
                      id="step4.recommended"
                      defaultMessage="(Recommended - previously used for this position)"
                    />
                  </span>
                </>
              )
              : (
                <span className={styles.surveyTitleText}>{name}</span>
              )}
          </div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
      );
    },
    width: 250
  },
  {
    Header: () => <FormattedMessage id="surveyTable.lastPosition" defaultMessage="Last position used" />,
    accessor: 'lastPosition',
    width: 145,
    Cell: ({ cell: { value } }) => (value
      ? <TextOverflowTooltip content={value} width={220}>{value}</TextOverflowTooltip>
      : <EmptyFieldPlaceholder />
    )
  },
  {
    Header: () => <FormattedMessage id="preview" defaultMessage="Preview" />,
    id: 'preview',
    Cell: ({ row: { original } }) => {
      const { id } = original as ISurvey;
      return (
        <div style={{ maxWidth: '65px' }} className="table-center table-actions">
          <PreviewIcon className={styles.previewIcon} onClick={() => onPreview(id)} />
        </div>
      );
    },
    width: 85
  }
];
